import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  deleteGenerationSite,
  listGenerationSites,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/** 発電所 (サイト) の削除 mutation (楽観ロック)。成功したら一覧を最新化する。 */
export function useDeleteGenerationSite(): InvalidatingMutationResultFor<
  typeof deleteGenerationSite
> {
  return useInvalidatingMutation(deleteGenerationSite, [
    createConnectQueryKey({
      schema: listGenerationSites,
      cardinality: 'finite',
    }),
  ])
}
